import { AdvancedTourStep } from '../shared-types';
import { ComponentTourProps } from './component-tour-props';

export function getIfRuleTourSteps({
	defaultStyles,
	hasIfRules = false,
}: ComponentTourProps): AdvancedTourStep[] {
	return [
		{
			id: 'rule-0',
			selector: '[data-tour="rule-0"]',
			content: 'Individual Rule Group to be used when comparing data.',
		},

		{
			id: 'and-or',
			selector: '[data-tour="and-or-0"]',
			content: 'Required: The logic that will be applied to the current Rule Group.',
		},
		{
			id: 'add-rule-0',
			selector: '[data-tour="add-rule-0"]',
			content: 'Add an additional rule to the current Rule Group.',
		},
		{
			id: 'add-group-0',
			selector: '[data-tour="add-group-0"]',
			content:
				'Adds an additional Rule Group to the current Rule Group, this is the equivalent of adding nested brackets to an if statement.',
		},
		...(hasIfRules
			? [
					{
						id: 'data-type-0',
						selector: '[data-tour="data-type-0"]',
						content: 'Required: Set the data-type of the items being compared.',
					},
					{
						id: 'value-a-0',
						selector: '[data-tour="value-a-0"]',
						content: 'Required: The value from Collection A to use in the Rule.',
					},
					{
						id: 'operator-0',
						selector: '[data-tour="operator-0"]',
						content: 'Required: The method of comparison.',
					},
					{
						id: 'value-b-0',
						selector: '[data-tour="value-b-0"]',
						content: 'Required: The value from Collection B to use in the Rule.',
					},
					{
						id: 'delete-rule-0',
						selector: '[data-tour="delete-rule-0"]',
						content: 'Removes the specific rule from the Rule Group.',
					},
				]
			: []),

		// commented out for a reason: not all task currently allow the dragging of rules.
		// {
		// 	id: 'drag-rule-0',
		// 	selector: '[data-tour="drag-rule-0"]',
		// 	content: 'Drag and drop rules to re-arrange the order in which the validation occurs.',
		// 	styles: defaultStyles,
		// },
	].map(tourItem => ({ ...tourItem, styles: defaultStyles }));
}
